import { useRef, useState } from 'react';
// material
import { Box, ListItemIcon, ListItemText, MenuItem } from '@material-ui/core';
// hooks
import useLocales from 'src/hooks/useLocales';
// components
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { MIconButton } from 'src/components/@material-extend';
import MenuPopover from 'src/components/MenuPopover';
import { LoginTooltip } from './StyledTooltip';

// ----------------------------------------------------------------------

interface LanguagePopoverProps {
  withTooltip?: boolean; // ツールチップを表示するかどうか
  onOpenChange?: (open: boolean) => void; // 言語選択メニュー開閉状態の変更時のコールバック
}

export default function LanguagePopover({ withTooltip = false, onOpenChange }: LanguagePopoverProps) {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { allLang, currentLang, onChangeLang } = useLocales();
  const { t } = useTranslation();

  // 言語選択メニュー開閉時の処理
  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
    onOpenChange?.(newOpen);
  };

  const languageButton = (
    <MIconButton
      ref={anchorRef}
      onClick={() => handleOpenChange(true)}
      sx={{
        padding: 0,
        width: 44,
        height: 44,
        fontSize: 30,
      }}>
      <FontAwesomeIcon icon={faGlobe} />
    </MIconButton>
  );

  return (
    <>
      {withTooltip ? (
        <LoginTooltip title={t('login.tooltip.languageChange')} open={true} placement="right" arrow>
          {languageButton}
        </LoginTooltip>
      ) : (
        languageButton
      )}

      <MenuPopover open={open} onClose={() => handleOpenChange(false)} anchorEl={anchorRef.current}>
        <Box sx={{ py: 1 }}>
          {allLang.map((option) => (
            <MenuItem
              key={option.value}
              selected={option.value === currentLang.value}
              onClick={() => {
                onChangeLang(option.value);
                handleOpenChange(false);
              }}
              sx={{ py: 1, px: 2.5 }}>
              <ListItemIcon children={option.code} sx={{ fontWeight: 'bold' }}></ListItemIcon>
              <ListItemText primaryTypographyProps={{ variant: 'body2' }}>{option.label}</ListItemText>
            </MenuItem>
          ))}
        </Box>
      </MenuPopover>
    </>
  );
}
